import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useState } from 'react'
import { SearchContext } from '../../../../../contexts/SearchContext'
import axiosService from '../../../../../utils/AxiosService'
import ReactMultiSelect from '../../../../FormComponents/ReactMultiSelect'

export default observer(function CityFilter() {
  const { search } = useContext(SearchContext)

  const [cityOptions, setCityOptions] = useState([])

  useEffect(() => getCityOptions(), [])

  const getCityOptions = () => {
    axiosService.get(`/api/project_manager/authentications/cities`)
    .then(cities => setCityOptions(cities.map((city) => ({ label: city, value: city }))))
  }

  const setCityFilter = (cities) => {
    search.city = cities.map(city => city.value)
    search.selectedCities = cities
  }

  return (
    <div className="w-full">
      <ReactMultiSelect
        placeholder="Any city"
        name="filter"
        onChange={setCityFilter}
        options={cityOptions}
        value={search.selectedCities}
        hasSelectAll={false}
      />
    </div>
  )
})